import { Injectable } from '@angular/core';
// import { initializeApp } from 'firebase/app';
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
    private messaging: any;
  private listenerInitialized = false;

  constructor() {
    // const app = initializeApp(environment.firebaseConfig);
      const app = getApps().length ? getApp() : initializeApp(environment.firebaseConfig);

    this.messaging = getMessaging(app);
  }

  async requestWebPermission(userId: any, saveTokenCallback: any) {
    const permission = await Notification.requestPermission();

    if (permission !== 'granted') {
      console.log('Web notification permission denied');
      return;
    }

    const token = await getToken(this.messaging, {
      vapidKey: environment.firebaseConfig.vapidKey,
    });

    console.log('FCM Token:', token);
    console.log(" CONFIG:", environment.firebaseConfig);
    // alert(token+"notification get token")

    if (token) {
      saveTokenCallback(token);
    }
  }

  listenForMessages() {
    if (this.listenerInitialized) {
      return;
    }

    this.listenerInitialized = true;

    onMessage(this.messaging, (payload) => {
      console.log('Foreground Web Message:', payload);
      // alert(payload.notification?.title + '\n' + payload.notification?.body);
    });
  }
}
